import React from 'react';
import { FourOhThree } from '@brighterionai/br-ui';
import Layout from 'Components/Layout';
import { useAppStore } from 'Store';

const ForbiddenPage: React.FC = () => {
    const logout = useAppStore.use.logout?.();

    return (
        <Layout>
            <FourOhThree tFunc={(str) => str} onLinkClick={logout} />
        </Layout>
    );
};

export default ForbiddenPage;
